<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.positionLevel"
        placeholder="职级"
      >
        <el-option
          v-for="(item, i) in positionLevelData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.leaderType"
        placeholder="管理主体"
      >
        <el-option
          v-for="(item, i) in leaderTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.cadreLevel"
        placeholder="干部级别"
      >
        <el-option
          v-for="(item, i) in cadreLevelData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.isExam"
        placeholder="考核用户"
      >
        <el-option
          v-for="(item, i) in examData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.userStatus"
        placeholder="用户状态"
      >
        <el-option
          v-for="(item, i) in userStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.roleId"
        placeholder="角色"
      >
        <el-option
          v-for="(item, i) in roleData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.auditStatus"
        placeholder="审核状态"
      >
        <el-option
          v-for="(item, i) in auditData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn" style="width: 150px">
      <el-select
        class="select_btn_style"
        v-model="filters.bindStatus"
        placeholder="浙政钉绑定状态"
      >
        <el-option
          v-for="(item, i) in userBindData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn" style="width: 150px">
      <el-select
        class="select_btn_style"
        v-model="filters.canVisitZwy"
        placeholder="能否访问中网院"
      >
        <el-option
          v-for="(item, i) in examData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="姓名/手机号"
      ></el-input>
    </el-form-item>
    <el-form-item class="m-l-14">
      <span>出生年月：</span>
      <el-date-picker
        v-model="monthRange"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        value-format="yyyy-MM-dd"
      />
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getRoleList } from "@/api/role";
import { getEnums } from "@/utils/common.js";
export default {
  components: { butn },
  // props: ['filters'],
  data() {
    return {
      filters: {},
      options: [],
      leaderTypeData: [],
      positionLevelData: [],
      examData: [],
      userStatusData: [],
      roleData: [],
      auditData: [],
      monthRange: [],
      userBindData: [],
      cadreLevelData: [],
    };
  },
  created() {
    getEnums(
      [
        "USER_LEADER_TYPE",
        "USER_STATUS",
        "USER_POSITION_LEVEL",
        "IS_VALID",
        "VIDEO_AUDIT_STATUS",
        "USER_BIND_STATUS",
        "CADRE_LEVEL",
      ],
      this,
      [
        "leaderTypeData",
        "userStatusData",
        "positionLevelData",
        "examData",
        "auditData",
        "userBindData",
        "cadreLevelData",
      ],
      [true, true, true, true, true, true, true]
    );
    getRoleList().then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        uuid: "",
        roleName: "全部",
      });
      this.roleData = res.data.map((ele) => ({
        paramKey: ele.uuid,
        paramValue: ele.roleName,
      }));
    });
  },
  methods: {
    initData() {
      const params = { ...this.filters };
      if (Array.isArray(this.monthRange) && this.monthRange.length > 0) {
        params.startDate = this.monthRange[0];
        params.endDate = this.monthRange[1];
      }
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.monthRange = [];
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  // text-align: right;
  line-height: 40px;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
}
/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 8px;
}
</style>
